import { skipToken, useSuspenseQuery } from "@apollo/client";

import { WASTE_LINES_UNIFIED_COUNT_QUERY } from "../../ManifestLineItems/api";
import { useFacilityWasteLineItemsDefaultSearch } from "./useFacilityWasteLineItemsDefaultSearch";

/**
 * Whether the facility has any waste at all in the active date range, which is
 * what the tiles' empty states are asking. Deliberately ignores the View
 * filter: 14% of facilities with waste this year ship nothing reportable, and
 * counting through the filter made every one of them render as having no data
 * and offer to add a manifest they already had.
 */
export function useHasWasteShipmentData({ skip = false }: { skip?: boolean } = {}) {
  const search = useFacilityWasteLineItemsDefaultSearch({ ignoreView: true });
  const { data } = useSuspenseQuery(
    WASTE_LINES_UNIFIED_COUNT_QUERY,
    skip ? skipToken : { variables: { search } }
  );
  return (data?.wasteLinesUnified?.count ?? 0) > 0;
}
